import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogueModule } from '@kp/dialogue/dialogue.module';
import { ScreenFeedbackModule } from '@kp/screen-feedback/screen-feedback.module';
import { ScreenHelpModule } from '@kp/screen-help/screen-help.module';
import { ScreenInitialModule } from '@kp/screen-initial/screen-initial.module';
import { ScreenLoginModule } from '@kp/screen-login/screen-login.module';
import { WINDOW_PROVIDERS } from '@kservice';

/**
 * Import/Export services, components and other elements that are core to the app
 * Do not import/export anything that will be lazy loaded
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DialogueModule,
    ScreenFeedbackModule,
    ScreenInitialModule,
    ScreenLoginModule,
    ScreenHelpModule,
  ],
  providers: [WINDOW_PROVIDERS],
  exports: [DialogueModule, ScreenFeedbackModule, ScreenInitialModule, ScreenLoginModule, ScreenHelpModule],
})
export class CoreModule {}
